















































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";
import { Menu } from "../../modules/Menu";
import * as Common from "../../commons/common";

export interface Data {
  errors: string[]
  loginId: string
  password: string
};

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
      loginId: "",
      password: "",
    });

    // ログインボタン押下
    const onSubmit = async () => {
      state.errors = [];
      if(state.loginId.length == 0){
        state.errors.push("ログインIDを入力してください。");
        return;
      }

      if(state.password.length == 0){
        state.errors.push("パスワードを入力してください。");
        return;
      }
      
      http.post("/api/login/student", {condition: {login_id: state.loginId, password: state.password, school_url_prefix: context.root.$route.params.school_url_prefix}})
        .then(response => {
          executeLogin(response);
      }).catch(error=>{
        if (error.response.status == 401) {
          state.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
        }
        if (error.response.status == 403) {
          state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
        }
        if (error.response.status == 406) {
          state.errors.push("現在メンテナンス中のためログインできません。");
        }
        if (error.response.status == 410) {
          state.errors.push("ログインに失敗しました。URLが不正です。");
        }
        if (error.response.status == 409) {
          state.errors.push("アカウントが無効になっているためログインできません。");
        }
      });
    }

    // ログイン成功後の後処理
    const executeLogin = (response: any) => {
      var user = response.data.user;

      // トークン設定
      var token = user.access_token
      document.cookie = `access_token=${token}`;
      document.cookie = 'smarky_user_id=' + user.id;
      document.cookie = `smarky_is_parent=${response.data.is_parent ? "1" : "0"}`;
      document.cookie = 'api_kind=';

      context.root.$store.commit("setCurrentUser", user);
      context.root.$store.commit("setStudentCode", response.data.student_code);
      context.root.$store.commit("setStudentName", context.root.$route.query.student_name);
      context.root.$store.commit("setIsParent", response.data.is_parent);

      if(context.root.$store.getters.isOptionLessonActive){
        context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/lesson_class_list`).catch(err => {});
      }else{
        context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/sheet_list`).catch(err => {});
      }
      
      context.root.$store.commit("setIsHeaderDisp", true);
    }

    /******************************
     * Googleログイン
     ******************************/

    const googleLogin = async () => {
      context.root.$store.dispatch("showOverlay");
      document.cookie = `api_kind=google_student_login`;
      document.cookie = `school_url_prefix=${context.root.$route.params.school_url_prefix}`;
      
      await http.post(`/api/google_sessions/create`).then(response => {
        if (response.data.auth_uri) {
          window.location.href = response.data.auth_uri;
        } else {
          state.errors = ["認証URLの取得に失敗しました。"];
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.commit("setSchoolUrlPrefix", context.root.$route.params.school_url_prefix);

      await http.get(`/api/session/school_logo_image?school_url_prefix=${context.root.$route.params.school_url_prefix}`).then(response => {
        if(response.data.base64_image == null){
          // @ts-ignore
          context.root.$store.commit("setBase64SchoolLogo", require("@/assets/images/logo_smarky_ol.png"));
        }else{
          context.root.$store.commit("setBase64SchoolLogo", `data:image/jpeg;base64,${response.data.base64_image}`);
        }

        if(context.root.$route.query.error_kind){
          const error_kind = context.root.$route.query.error_kind as string;

          if(error_kind == "user_not_exists"){
            state.errors.push("お試しいただいたGoogleアカウントではログインできません。");
          }else if(error_kind == "mainte"){
            state.errors.push("現在メンテナンス中のためログインできません。");
          }else if(error_kind == "login_failed_not_active"){
            state.errors.push("アカウントが無効になっているためログインできません。");
          }else if(error_kind == "login_failed_count_over"){
            state.errors.push("ログイン失敗回数の制限を超えたためログインできません。管理者に問い合わせてください。");
          }else if(error_kind == "school_url_prefix_not_exists"){
            state.errors.push("URLが不正です。");
          }else if(error_kind == "session_timeout"){
            state.errors.push("一定時間サーバーと通信がなかったためログアウトしました。");
          }else{
            state.errors.push("ログインに失敗しました。予期せぬエラーが発生しました。");
          }
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          console.log(error.response.data.errors);
        }
      });
      context.root.$store.commit("setIsHeaderDisp", false);
    })

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      onSubmit,
      googleLogin,
    }
  }
})
